import { WhoAmI } from 'types/GlobalAuthentication'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

export async function whoAmI() {
  const url = `${BASE_URL}who-am-i`

  return getWithRedirect<{ attributes: WhoAmI }>(url)
}
